import { Routes } from '@angular/router';
import { provideSchoolStore } from '@app/store/school';
import { provideUsersImporterStore } from '@app/store/users-importer';
import { ModalComponent } from '@shared/components';
import { AddComponent } from './add/add.component';
import { ViewComponent } from './view/view.component';
import { EditComponent } from './edit/edit.component';

export const schoolsModalRoutes: Routes = [
    {
        path: 'schools/add',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideSchoolStore()],
        children: [{ path: '', component: AddComponent }],
    },
    {
        path: 'schools/view/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideSchoolStore(), ...provideUsersImporterStore()],
        children: [{ path: '', component: ViewComponent }],
    },
    {
        path: 'schools/edit/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideSchoolStore(), ...provideUsersImporterStore()],
        children: [{ path: '', component: EditComponent }],
    },
];
